"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RemovePropertyDialogModule = /** @class */ (function () {
    function RemovePropertyDialogModule() {
    }
    return RemovePropertyDialogModule;
}());
exports.RemovePropertyDialogModule = RemovePropertyDialogModule;
